// extracted by mini-css-extract-plugin
export default {"container":"CommunityTagsFilter_container__KW1aO","deleteIcon":"CommunityTagsFilter_deleteIcon__Gmg0E"};